import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Controller } from 'react-hook-form';
import { SearchLG } from 'untitledui-js-base';
import { handleEnterAsTab } from '../../../utils/handleEnterAsTab';
import { UserPrefix } from '../AccidenCreatingStepCustomerInformations';

/** IČO + ARES tlačítko + Obchodní název (volitelně) + DIČ + Plátce DPH */
export const CompanyFields = ({
  prefix,
  control,
  ico,
  showCompanyName,
  isAresDataLoading,
  onAresClick,
  onSystemSearch
}: {
  prefix: UserPrefix;
  control: any;
  ico: string;
  showCompanyName: boolean;
  isAresDataLoading?: boolean;
  onAresClick: () => void;
  onSystemSearch: () => void;
}) => (
  <Stack gap={2}>
    <Grid container columns={12} spacing={2} alignItems="center">
      <Grid size={{ xs: 7, md: 10 }}>
        <Controller
          control={control}
          name={`${prefix}.company.companyIdNum`}
          render={({ field }) => (
            <TextField
              {...field}
              value={field.value ?? ''}
              label="IČO"
              color="secondary"
              fullWidth
              InputLabelProps={{ shrink: true }}
              slotProps={{
                htmlInput: { maxLength: 8 },
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="Nahrát ze systému">
                        <IconButton
                          edge="end"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={onSystemSearch}
                          disabled={!ico}
                          color="primary"
                        >
                          <SearchLG />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  )
                }
              }}
              onKeyDown={handleEnterAsTab}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 5, md: 2 }}>
        <Tooltip title="Nahrát z ARES">
          <Button
            variant="contained"
            color="info"
            onClick={onAresClick}
            disabled={!ico}
            loading={isAresDataLoading}
            size="large"
            sx={{ paddingX: 2 }}
            startIcon={<SearchLG />}
          >
            ARES
          </Button>
        </Tooltip>
      </Grid>
    </Grid>

    {showCompanyName && (
      <Controller
        control={control}
        name={`${prefix}.company.companyName`}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value ?? ''}
            label="Obchodní název"
            color="secondary"
            fullWidth
            InputLabelProps={{ shrink: true }}
            onKeyDown={handleEnterAsTab}
          />
        )}
      />
    )}

    <Grid container alignItems="center" spacing={2} columns={12}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          control={control}
          name={`${prefix}.company.companyTaxNum`}
          render={({ field }) => (
            <TextField
              {...field}
              value={field.value ?? ''}
              label="DIČ"
              color="secondary"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onKeyDown={handleEnterAsTab}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          control={control}
          name={`${prefix}.company.companyVatPayer`}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  color="success"
                />
              }
              label="Plátce DPH"
            />
          )}
        />
      </Grid>
    </Grid>
  </Stack>
);
